import Forms from "./Forms/routes.js";
import InformationSafetyManager from "./InformationSafetyManager/routes.js";
import InformationSecurityRisks from "./InformationSecurityRisks/routes.js";
import RiskRegister from "./RiskRegister/routes.js";
import SafetyMonitoringReports from "./SafetyMonitoringReports/routes.js";
import SafetyObjectiveRegister from "./SafetyObjectiveRegister/routes.js";
import SafetyReviewBoardMeetings from "./SafetyReviewBoardMeetings/routes.js";
import Settings from "./Settings/routes.js";

export default [...Forms, ...RiskRegister, ...SafetyObjectiveRegister, ...SafetyMonitoringReports, ...SafetyReviewBoardMeetings, ...InformationSafetyManager, ...InformationSecurityRisks, ...Settings];
